import React from 'react';
import PageLoader from './PageLoader';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router';

function Page({ loading, children, className, title, meta, ...props }) {
	if (loading) return <PageLoader />;
	else
		return (
			<div className={`page-root ${className || ''}`}>
				<Helmet>
					<title>{meta && meta.title ? meta.title : title}</title>
					<meta name="description" content={(meta && meta.description) || ''} />
				</Helmet>
				{children}
			</div>
		);
}

export default withRouter(Page);
